export enum keysName {
  SeeAll = 'Voir tout',
  Machines = 'Machines',
  JobSites = 'Chantiers',
  Agencies = 'Agences',
}
